import styledNormalize from 'styled-normalize'

import theme from './theme'
import fonts from './fonts'

export default `
  ${styledNormalize}

  body {
    margin: 0;
    padding: 0;
    font-family: ${theme.bodyFont};
    -webkit-font-smoothing: antialiased;
  }

  p {
    margin: 0;
    margin-bottom: 20px;
  }

  h1, h2, h3, h4, h5 {
    margin: 0;
    margin-bottom: 30px;
    font-weight: 300;
    font-family: ${theme.displayFont};
  }

  h3, h4, h5 {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 30px;
    line-height: 45px;
  }

  h2 {
    font-size: 22px;
    line-height: 28px;
  }

  h3 {
    font-size: 14px;
    line-height: 20px;
  }

  * {
    box-sizing: border-box;
  }

  img, svg {
    display: block;
  }

  a {
    text-decoration: none;
    color: ${theme.colors.primary};
  }

  /**
   * Bootstrap utils
   **/

  .noGutters {
    margin-right: 0;
    margin-left: 0;

    > div {
      padding-right: 0;
      padding-left: 0;
    }
  }


  ${fonts}
`



// WEBPACK FOOTER //
// ./src/ui/styles/global.js